module.exports = __webpack_public_path__ + "img/스포츠베팅하기.b108d6fb.png";